<template>
  <div class="class-list-page">
    <!-- 顶部区域 -->
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">📚 课程中心</h1>
        <p class="page-subtitle">专业视光课程，助力职业成长</p>
      </div>
    </div>

    <!-- Tab分类骨架屏 -->
    <div class="tab-skeleton-container" v-if="loading">
      <div class="tab-skeleton-list">
        <div class="tab-skeleton-item" v-for="i in 4" :key="i"></div>
      </div>
    </div>

    <!-- Tab分类 -->
    <div class="tab-container" v-else>
      <van-tabs
        v-model="active1"
        @click="tab_click"
        @rendered="tab_click"
        color="#d51900"
        title-active-color="#d51900"
        line-width="24"
        line-height="3"
        class="main-tabs"
      >
        <van-tab
          v-for="item in class_tab_list"
          :key="item.Id"
          :name="item.Id"
          :title="item.Name"
        >
          <!-- 二级分类 -->
          <van-tabs
            v-if="item.resultCurriculumGroups && item.resultCurriculumGroups.length > 0"
            @click="tab_click"
            color="#d51900"
            title-active-color="#d51900"
            class="sub-tabs"
          >
            <van-tab
              v-for="subItem in item.resultCurriculumGroups"
              :name="subItem.Id"
              :key="subItem.Id"
              :title="subItem.Name"
            />
          </van-tabs>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 课程列表 -->
    <div class="course-container">
      <!-- 课程骨架屏 -->
      <div class="course-skeleton-list" v-if="loading || coursesLoading">
        <div class="course-skeleton-card" v-for="i in 4" :key="i">
          <div class="skeleton-image"></div>
          <div class="skeleton-content">
            <div class="skeleton-line skeleton-title-line"></div>
            <div class="skeleton-action-area">
              <div class="skeleton-line skeleton-action"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="course-list" v-else-if="class_list.length > 0">
        <div
          class="course-card"
          :class="{ 'course-locked': !item.IsUnlocked }"
          v-for="(item, index) in class_list"
          :key="item.Id"
          :style="{ animationDelay: index * 0.08 + 's' }"
          @click="class_details(item)"
        >
          <div class="course-image-wrapper">
            <img :src="item.Thumbnail" :alt="item.Subject" class="course-image" />
            <div v-if="getLinkExtension(item.Link)" class="course-badge">
              {{ getLinkExtension(item.Link) }}
            </div>
            <!-- 锁定遮罩 -->
            <div v-if="!item.IsUnlocked" class="lock-overlay">
              <div class="lock-icon">🔒</div>
            </div>
            <div class="course-overlay"></div>
          </div>
          <div class="course-content">
            <h4 class="course-title">{{ item.Subject }}</h4>
            <div class="course-action" v-if="item.IsUnlocked">
              <span class="action-text">立即学习</span>
              <span class="action-arrow">→</span>
            </div>
            <div class="course-action locked-action" v-else>
              <span class="action-text">点击了解解锁规则</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="!loading && class_list.length === 0" class="empty-state">
        <div class="empty-icon">📭</div>
        <p class="empty-text">该分类暂无课程</p>
      </div>
    </div>

    <!-- 密码弹窗 -->
    <van-dialog
      v-model="show_password"
      @confirm="confirm_pass"
      @cancel="show_password = false"
      title="请输入课程密码"
      show-cancel-button
      confirm-button-color="#d51900"
    >
      <div class="password-input-wrapper">
        <van-field
          v-model="PassWord_value"
          type="password"
          input-align="center"
          placeholder="请输入密码"
          class="password-field"
        />
      </div>
    </van-dialog>

    <!-- 解锁提示弹窗 -->
    <unlock-tip-dialog
      :show.sync="show_unlock_tip"
      :unlock-data="unlockTipData"
      :loading="unlockTipLoading"
      @go-course="goToPreCourse"
    />
  </div>
</template>

<script>
import { WeChatCurriculum_GetCurricularGroup, WeChatCurriculum_GetCurriculaByGroupId, WeChatCurriculumUnlock_BatchCheckUnlockStatus } from '../api/api'
import UnlockTipDialog from '../components/UnlockTipDialog.vue'

export default {
  name: 'class_list',
  components: {
    UnlockTipDialog
  },
  data() {
    return {
      kc_details: {},
      PassWord_value: '',
      show_password: false,
      show_unlock_tip: false,
      unlockTipData: {},
      unlockTipLoading: false,
      active1: 0,
      class_tab_list: [],
      class_list: [],
      loading: true,
      coursesLoading: false,
      tabLoadToken: 0
    }
  },
  async mounted() {
    this.loading = true
    try {
      const { data } = await WeChatCurriculum_GetCurricularGroup()
      this.class_tab_list = data.response || []
    } finally {
      this.loading = false
    }
  },
  methods: {
    getLinkExtension(link) {
      if (link && typeof link === 'string') {
        const parts = link.split('.')
        if (parts.length > 1) {
          const ext = parts[parts.length - 1].toUpperCase()
          return ext === 'MP4' ? '视频' : ext
        }
      }
      return ''
    },
    confirm_pass() {
      if (this.kc_details.PassWord === this.PassWord_value) {
        this.$router.push({
          path: '/classStudy',
          query: { ids: this.kc_details.Id }
        })
      } else {
        this.$toast('密码错误')
      }
    },
    async class_details(item) {
      if (this.unlockTipLoading) return
      // 检查是否已解锁
      if (!item.IsUnlocked) {
        // 先显示弹框骨架屏
        this.unlockTipData = {}
        this.unlockTipLoading = true
        this.show_unlock_tip = true

        try {
          // 调用接口获取完整解锁信息
          const openId = localStorage.getItem('openid')
          const { data } = await WeChatCurriculumUnlock_BatchCheckUnlockStatus([item.Id], openId)
          if (data.success && data.response && data.response.length > 0) {
            const status = data.response[0]
            this.unlockTipData = {
              UnlockRuleDesc: status.UnlockRuleDesc || '需完成前置课程',
              UnlockProgress: status.UnlockProgress || '',
              UnfinishedPreCurriculums: status.UnfinishedPreCurriculums || [],
              PreCurriculumList: status.PreCurriculumList || [],
              UnlockRules: status.UnlockRules || []
            }
          } else {
            // 使用本地数据作为备用
            this.unlockTipData = {
              UnlockRuleDesc: item.UnlockRuleDesc || '需完成前置课程',
              UnlockProgress: item.UnlockProgress || '',
              UnfinishedPreCurriculums: item.UnfinishedPreCurriculums || [],
              PreCurriculumList: item.PreCurriculumList || [],
              UnlockRules: item.UnlockRules || []
            }
          }
        } catch (e) {
          // 使用本地数据作为备用
          this.unlockTipData = {
            UnlockRuleDesc: item.UnlockRuleDesc || '需完成前置课程',
            UnlockProgress: item.UnlockProgress || '',
            UnfinishedPreCurriculums: item.UnfinishedPreCurriculums || [],
            PreCurriculumList: item.PreCurriculumList || [],
            UnlockRules: item.UnlockRules || []
          }
        } finally {
          this.unlockTipLoading = false
        }
        return
      }

      if (item.PassWord) {
        this.PassWord_value = ''
        this.kc_details = item
        this.show_password = true
      } else {
        this.$router.push({
          path: '/classStudy',
          query: { ids: item.Id }
        })
      }
    },
    async tab_click(name) {
      const token = ++this.tabLoadToken
      this.coursesLoading = true
      try {
        const { data } = await WeChatCurriculum_GetCurriculaByGroupId({ Id: name })
        if (token !== this.tabLoadToken) return
        let courseList = data.response || []

        // 获取课程解锁状态
        if (courseList.length > 0) {
          const openId = localStorage.getItem('openid')
          if (openId) {
            const curriculumIds = courseList.map(c => c.Id)
            try {
              const unlockRes = await WeChatCurriculumUnlock_BatchCheckUnlockStatus(curriculumIds, openId)
              if (token !== this.tabLoadToken) return
              if (unlockRes.data && unlockRes.data.success) {
                const unlockStatusMap = {}
                unlockRes.data.response.forEach(status => {
                  unlockStatusMap[status.CurriculumId] = status
                })
                // 合并解锁状态到课程列表
                courseList = courseList.map(course => ({
                  ...course,
                  IsUnlocked: unlockStatusMap[course.Id] ? unlockStatusMap[course.Id].IsUnlocked : true,
                  UnlockProgress: unlockStatusMap[course.Id] ? unlockStatusMap[course.Id].UnlockProgress : '',
                  UnlockRuleDesc: unlockStatusMap[course.Id] ? unlockStatusMap[course.Id].UnlockRuleDesc : '',
                  UnfinishedPreCurriculums: unlockStatusMap[course.Id] ? unlockStatusMap[course.Id].UnfinishedPreCurriculums : [],
                  PreCurriculumList: unlockStatusMap[course.Id] ? unlockStatusMap[course.Id].PreCurriculumList : [],
                  UnlockRules: unlockStatusMap[course.Id] ? unlockStatusMap[course.Id].UnlockRules : []
                }))
              }
            } catch (e) {
              console.log('获取解锁状态失败', e)
              // 获取失败时默认全部解锁
              courseList = courseList.map(course => ({ ...course, IsUnlocked: true }))
            }
          } else {
            // 未登录时默认全部解锁
            courseList = courseList.map(course => ({ ...course, IsUnlocked: true }))
          }
        }

        if (token !== this.tabLoadToken) return
        this.class_list = courseList
      } finally {
        if (token === this.tabLoadToken) {
          this.coursesLoading = false
        }
      }
    },
    goToPreCourse(course) {
      this.show_unlock_tip = false
      this.$nextTick(() => {
        this.$router.push({
          path: '/classStudy',
          query: { ids: course.Id }
        })
      })
    }
  }
}
</script>

<style scoped>
.class-list-page {
  min-height: 100vh;
  background: #f5f9fc;
  /* 防止闪烁 - Android/iOS 兼容 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
}

/* 顶部区域 */
.page-header {
  background: #fff;
  padding: 20px 20px 10px;
  text-align: center;
  border-bottom: 1px solid #f0f4f8;
}

.page-title {
  font-size: 20px;
  font-weight: 800;
  color: #1a2a3a;
  margin: 0 0 4px;
  letter-spacing: 0.5px;
}

.page-subtitle {
  font-size: 13px;
  color: #8a9aaa;
  margin: 0;
}

/* Tab容器 */
.tab-container {
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

/* Tab骨架屏 */
.tab-skeleton-container {
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 12px 16px;
}

.tab-skeleton-list {
  display: flex;
  gap: 16px;
  overflow: hidden;
}

.tab-skeleton-item {
  flex-shrink: 0;
  width: 60px;
  height: 28px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
}

.tab-skeleton-item:first-child {
  width: 50px;
}

.tab-skeleton-item:nth-child(2) {
  width: 70px;
}

.tab-skeleton-item:nth-child(3) {
  width: 55px;
}

.main-tabs {
  font-weight: 600;
}

.sub-tabs {
  border-top: 1px solid #f0f4f8;
}

/* 课程容器 */
.course-container {
  padding: 16px;
  min-height: calc(100vh - 200px);
}

/* 课程列表 */
.course-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 课程骨架屏 */
.course-skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.course-skeleton-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.skeleton-image {
  width: 100%;
  /* 16:9 比例 */
  aspect-ratio: 16 / 9;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.skeleton-content {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-title-line {
  height: 16px;
  width: 65%;
}

.skeleton-action-area {
  margin-left: 12px;
}

.skeleton-action {
  height: 14px;
  width: 70px;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.course-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  /* 防止闪烁 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.course-card:active {
  opacity: 0.9;
}

.course-image-wrapper {
  position: relative;
  width: 100%;
  /* 16:9 比例 */
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #f0f2f5;
}

.course-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.course-card:active .course-image {
  transform: scale(1.05);
}

.course-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.2), transparent);
}

.course-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(213, 25, 0, 0.9);
  color: #ffffff;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.course-content {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.course-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a2a3a;
  margin: 0;
  flex: 1;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-right: 12px;
}

.course-action {
  display: flex;
  align-items: center;
  color: #d51900;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.action-arrow {
  margin-left: 4px;
  transition: transform 0.3s ease;
}

.course-card:active .action-arrow {
  transform: translateX(4px);
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 14px;
  color: #8a9aaa;
  margin: 0;
}

/* 密码输入弹窗 */
.password-input-wrapper {
  padding: 20px;
}

.password-field {
  background: #f5f9fc !important;
  border-radius: 12px !important;
}

/* 课程锁定样式 */
.course-locked {
  opacity: 0.85;
}

.course-locked .course-image {
  filter: grayscale(30%);
}

.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.lock-icon {
  font-size: 40px;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
}

.locked-action {
  color: #999 !important;
  font-size: 12px !important;
}

</style>

<style>
/* 全局Tab样式覆盖 */
.class-list-page .van-tabs__nav {
  background: transparent !important;
}

.class-list-page .van-tab {
  font-size: 14px !important;
}

.class-list-page .van-tab--active {
  font-weight: 700 !important;
}

.class-list-page .van-tabs__line {
  border-radius: 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/class_list.vue